import {
  IncentiveCatalogPicker,
  IncentiveCatalogPickerProps,
} from './IncentiveCatalogPicker';

export const IncentiveCollectionPicker = (
  props: IncentiveCatalogPickerProps,
) => <IncentiveCatalogPicker {...props} resource="collections" />;
